import { saveAs } from "file-saver";
import mainurl from "../config/mainurl.mjs";
import "./css/complete.css";
import { Icon } from "@iconify/react";
import { Link, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import secureLocalStorage from "react-secure-storage";


function Complete() {
  const Navigate=useNavigate();
  let pdf = {};
  const clientcode = secureLocalStorage.getItem("CC");
  const uid=secureLocalStorage.getItem('uid')
  async function downloadpdf() {
    await fetch(`${mainurl}/completeform`, {
      method: "POST",
      headers: { "Content-Type": "application/json","Authorization":"Basic RERQSS1BRlNMLUxJVkUtVjE6YXdlciQlY3MzNDVkXnp4dHkyNkAjZmdocVNEKmFa" },
      body: JSON.stringify({
        cc: clientcode,
      }),
    })
      .then((resp) => resp.text())
      .then((result) => {
        Object.assign(pdf, JSON.parse(result));
        const srcpdf = `data:application/pdf;base64,${pdf.content}#toolbar=0&scrollbar=0`;
        saveAs(srcpdf, `DDPI_form-${clientcode}`);
        setTimeout(secureLocalStorage.clear(),3000);
      }).catch(error=>{
      });
  }

  window.onpopstate = (e) =>{
    secureLocalStorage.clear();
    Navigate('/')
  }

  useEffect(()=>{
    if (secureLocalStorage.getItem("status")!==`${uid}finish`) {
      secureLocalStorage.clear();
      Navigate("/");
    }
  },[])

  return (
    <>
      <div className="container">
      <button className="link-text absolute flex items-center text-sm bottom-4 left-2 md:left-10">
        <Icon icon="mdi:arrow-left" color="gray" />
        <Link to="https://almondztrade.com" onClick={()=>secureLocalStorage.clear()}>Back to home</Link>
      </button>
        <div className="complete-container">
          <div className="upper-column">
            <div className="">
              <svg
                class="checkmark"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 52 52"
              >
                <circle
                  class="checkmark__circle"
                  cx="26"
                  cy="26"
                  r="25"
                  fill="none"
                />
                <path
                  class="checkmark__check"
                  fill="none"
                  d="M14.1 27.2l7.1 7.2 16.7-16.8"
                />
              </svg>
            </div>
            <p className="text-[16px] text-center font-semibold mt-8 mb-8">
              Congratulations!
            </p>
            <p className="para text-center leading-[20px]">
              Your DDPI Request has been submitted.<br></br> Please note
              that it may take up to 48 hours to activate the DDPI.
              {/* <Link className="text-orange-500" onClick={()=>downloadpdf()}>Click here</Link> to Download E-Signed DDPI Document. */}
            </p>
          </div>
          <div className="absolute w-full bottom-[8vh]">
            <button className="active-btn" onClick={() => downloadpdf()}>
              Download Form
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
export default Complete;
